import styled from 'styled-components';

import { fonts, spacing } from '../../modules/metrics';

export const Wrapper = styled.div`
  font-size: ${fonts.sm}px;
  color: red;
  padding-top: ${spacing.sm}px;
  ${(props) => props.extraSpace && `margin-bottom: ${spacing.sm}px;`}
`;
